var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 46,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7868 22.6204C68.4544 27.2282 67.2022 31.5604 65.9481 35.8926C65.0785 38.8931 64.192 41.888 63.3504 44.8959C63.1806 45.5031 62.9174 45.7061 62.2643 45.7042C51.1381 45.68 40.0139 45.6837 28.8877 45.6986C28.3074 45.6986 28.0237 45.5701 27.8483 44.9592C25.8067 37.8221 23.7315 30.6962 21.6675 23.5647C21.6022 23.3393 21.5798 23.1028 21.5107 22.7303C25.1647 25.0994 28.6918 27.3866 32.3682 29.7687V20.4692C36.9589 24.7362 41.3482 28.8132 45.8214 32.9703C50.0595 28.8505 54.2864 24.7418 58.5133 20.6313C58.5879 20.6573 58.6644 20.6834 58.7391 20.7095V29.8115C62.4994 27.3623 66.0377 25.0584 69.7906 22.6167L69.7868 22.6204Z",
    fill: "var(--color-color7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1803 47.7642V71.2466H36.6025V47.7642H55.1803Z",
    fill: "var(--color-color7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedIcon);
export default __webpack_public_path__ + "static/media/automated-icon.c50fd19cab7cf0066494a5920c7a3def.svg";
export { ForwardRef as ReactComponent };